import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../layout/MainLayout';

const useStyles = makeStyles(() => ({
    bg: {
        background: `url('../assets/bg.png')`,
        backgroundSize: 'cover',
        minHeight: '100vh',
        height: 'auto',
        width: '100vw',
        marginRight: '-20px !important',
        marginLeft: '-20px !important',
        display: 'flex',
        justifyContent: 'center',
    },
    title: {
        color: 'white',
        cursor: 'pointer',
        fontFamily: ['Poppins', 'regular'].join(','),
        fontSize: 24,
        textAlign: 'center',
    },

    margin: {
        margin: 'px 0px 40px 0px',
        textAlign: 'center',
    },
    text: {
        color: '#383838',
        fontSize: '16px',
        fontFamily: ['Poppins', 'regular'].join(','),
    },
}));

export default () => {
    const classes = useStyles();
    const { t } = useTranslation(['messages']);
    return (
        <MainLayout>
            <div className={classes.bg}>
                <Grid
                    container
                    justify="flex-start"
                    alignItems="center"
                    direction="column"
                    style={{ margin: 50 }}
                >
                    <Grid item lg={6} md={6} sm={12}>
                        <Grid item className={classes.margin}>
                            <Typography className={classes.title} variant="h4" color="initial">
                                {t('messages:title')}
                            </Typography>
                        </Grid>
                        <br />
                        <Grid item>
                            <Typography className={classes.text} variant="h6">
                                {t('messages:text')}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </MainLayout>
    );
};
